<template>
  <div class="analytics-detailed-stats-panel">
    <div v-for="item in data" :key="item.id" class="analytics-detailed-stats-panel__item">
      <span class="analytics-detailed-stats-panel__label">{{ item.label }}</span>
      <span class="analytics-detailed-stats-panel__value">{{ item.value }}</span>
      <!-- <span 
        class="analytics-detailed-stats-panel__change"
        :class="{
          'analytics-detailed-stats-panel__change--positive': isPositive(item.change),
          'analytics-detailed-stats-panel__change--neutral': !isPositive(item.change)
        }"
      >
        {{ formatChange(item.change) }}
      </span> -->
    </div>
  </div>
</template>
<script>
import { AnalyticsSubTabsKey } from '@/views/Analytics/AnalyticsHeader';
import numberWithSpacesCeilRound from '@/mixin/numberWithSpaces';

export default {
  name: 'AnalyticsDetailedStatsPanel',
  components: {},
  props: {
    data: {
      type: Array,
      defailt: () => [],
    },
  },
  mixins: [numberWithSpacesCeilRound],
  data() {
    return {
      AnalyticsSubTabsKey,
    };
  },
  computed: {},
  methods: {
    isPositive(change) {
      if (typeof change !== 'number') return false;
      return change > 0;
    },
    formatChange(change) {
      if (typeof change !== 'number') return '';
      if (change === 0) return '0%';
      const sign = change > 0 ? '+ ' : '- ';
      // Заменяем точку на запятую для русской локали
      return sign + Math.abs(this.numberWithSpacesCeilRound(change)) + '%';
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.analytics-detailed-stats-panel {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 20px;
  padding: 2rem 0 2.4rem;

  @include below(1441px) {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  }

  @include below(768px) {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 6px;
    padding-block: 20px;
    background: $basicWhite;
    box-shadow: 0px 2.5px 5px 0px $gray8;
  }

  &__label {
    margin-bottom: 24px;
    font-size: 16px;
    color: $basicBlack;
    text-align: center;
  }

  &__value {
    color: $basicBlack;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 5px;
  }

  &__change {
    font-size: 16px;

    &--neutral {
      color: $redLight;
    }
    &--positive {
      color: $greenClassic;
    }
  }
}
</style>
